/* ==========================================================================
   Marketing Layout
   Task F33: Shared layout wrapper for standalone (non-portal) pages
   Composes MarketingHeader + MarketingFooter around page content.
   ========================================================================== */

import { MarketingHeader } from './MarketingHeader'
import { MarketingFooter } from './MarketingFooter'

interface MarketingLayoutProps {
  /** Page content rendered between header and footer */
  children: React.ReactNode
  /** Right-side header navigation (links, buttons, etc.) */
  nav?: React.ReactNode
  /** Whether to show the footer (default: true) */
  showFooter?: boolean
}

export function MarketingLayout({
  children,
  nav,
  showFooter = true,
}: MarketingLayoutProps) {
  return (
    <div className="min-h-screen bg-warm-beige">
      <MarketingHeader>{nav}</MarketingHeader>
      {children}
      {showFooter && <MarketingFooter />}
    </div>
  )
}

export default MarketingLayout
